// src/utils/formatEventDate.js

/**
 * Safely formats a date string into "MMM dd, yyyy".
 * Returns "No date available" if the input is falsy
 * or "Invalid date" if an error occurs.
 */
export const formatEventDate = (date) => {
    try {
      return date
        ? new Date(date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
          })
        : "No date available";
    } catch {
      return "Invalid date";
    }
  };
  